import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, Teleport as _Teleport, createBlock as _createBlock, vModelRadio as _vModelRadio } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal mx-6 pt-6"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = ["disabled"];
const _hoisted_5 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_6 = {
  class: "data-table-shell"
};
const _hoisted_7 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_8 = {
  class: "data-table text-sm min-w-[1100px]"
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "font-mono text-slate-900 text-xs"
};
const _hoisted_12 = {
  key: 0,
  class: "status-badge is-warning ml-1"
};
const _hoisted_13 = {
  class: "data-table-td"
};
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = {
  class: "text-sm text-slate-900"
};
const _hoisted_16 = {
  class: "text-xs text-slate-500"
};
const _hoisted_17 = {
  class: "data-table-td"
};
const _hoisted_18 = {
  class: "text-sm text-slate-900"
};
const _hoisted_19 = {
  class: "font-mono text-xs text-slate-500"
};
const _hoisted_20 = {
  class: "text-xs text-slate-500"
};
const _hoisted_21 = {
  key: 1
};
const _hoisted_22 = {
  class: "data-table-td is-right"
};
const _hoisted_23 = {
  class: "money-text"
};
const _hoisted_24 = {
  class: "data-table-td is-right text-slate-600"
};
const _hoisted_25 = {
  class: "data-table-td is-center"
};
const _hoisted_26 = {
  class: "flex items-center justify-center gap-2"
};
const _hoisted_27 = {
  class: "w-20 h-1.5 bg-slate-200 rounded-full overflow-hidden"
};
const _hoisted_28 = {
  class: "text-xs text-slate-500"
};
const _hoisted_29 = {
  class: "data-table-td"
};
const _hoisted_30 = {
  class: "data-table-td text-slate-600 text-xs"
};
const _hoisted_31 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_32 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_37 = {
  class: "text-sm text-slate-500 font-mono"
};
const _hoisted_38 = {
  key: 0,
  class: "flex-1 overflow-y-auto min-h-0 p-6 space-y-4"
};
const _hoisted_39 = {
  class: "grid grid-cols-3 gap-3"
};
const _hoisted_40 = {
  class: "bg-slate-50 rounded-lg p-3"
};
const _hoisted_41 = {
  class: "text-sm font-semibold text-slate-900 money-text"
};
const _hoisted_42 = {
  class: "bg-emerald-50 rounded-lg p-3"
};
const _hoisted_43 = {
  class: "text-sm font-semibold text-emerald-700 money-text"
};
const _hoisted_44 = {
  class: "bg-amber-50 rounded-lg p-3"
};
const _hoisted_45 = {
  class: "text-sm font-semibold text-amber-700 money-text"
};
const _hoisted_46 = {
  class: "bg-slate-50 rounded-xl border border-slate-200 p-4"
};
const _hoisted_47 = {
  class: "flex items-center justify-between flex-wrap gap-2 mb-3"
};
const _hoisted_48 = {
  class: "text-sm text-slate-900"
};
const _hoisted_49 = {
  class: "font-mono text-xs text-slate-500 ml-1"
};
const _hoisted_50 = {
  class: "text-xs text-slate-500"
};
const _hoisted_51 = {
  class: "rounded-lg border border-emerald-200 bg-emerald-50 p-3"
};
const _hoisted_52 = {
  class: "text-xs text-slate-500 mb-1"
};
const _hoisted_53 = {
  class: "text-sm text-slate-900"
};
const _hoisted_54 = {
  key: 0,
  class: "money-text font-semibold"
};
const _hoisted_55 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_56 = {
  class: "text-xs text-slate-500 mt-1"
};
const _hoisted_57 = {
  class: "flex flex-wrap items-end gap-3"
};
const _hoisted_58 = {
  class: "form-label"
};
const _hoisted_59 = {
  class: "flex-1 min-w-[200px]"
};
const _hoisted_60 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_61 = ["disabled"];
const _hoisted_62 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_63 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6"
};
const _hoisted_64 = {
  class: "flex items-center gap-2 mr-6 cursor-pointer"
};
const _hoisted_65 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_66 = {
  key: 0,
  class: "mb-4 ml-[100px] max-w-xl"
};
const _hoisted_67 = {
  class: "rounded-lg border border-emerald-200 bg-emerald-50 p-3"
};
const _hoisted_68 = {
  class: "text-xs text-slate-500 mb-1"
};
const _hoisted_69 = {
  class: "text-sm text-slate-900"
};
const _hoisted_70 = {
  key: 0,
  class: "money-text font-semibold"
};
const _hoisted_71 = {
  key: 1,
  class: "text-slate-400"
};
const _hoisted_72 = {
  class: "text-xs text-slate-500 mt-1"
};
const _hoisted_73 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
};
const _hoisted_74 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_75 = ["disabled"];
import { ref, reactive, computed, watch, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import { downloadBlob, formatDateCompact } from '@/utils/download';
import { getFundTaskPage, createFundTask, cancelFundTask, exportFundTaskList, getBankCardPage, getBankCardOwners, createFundTaskRecord } from '@/api/taxPlanning';
export default {
  __name: 'FundTaskManagement',
  setup(__props) {
    const router = useRouter();
    const taskTypeMap = {
      1: {
        label: '税筹派发',
        class: 'status-badge is-indigo'
      },
      2: {
        label: '利润回填',
        class: 'status-badge is-teal'
      },
      default: {
        label: '未知',
        class: 'status-badge is-neutral'
      }
    };
    const taskStatusMap = {
      0: {
        label: '待处理',
        class: 'status-badge is-warning'
      },
      1: {
        label: '处理中',
        class: 'status-badge is-info'
      },
      2: {
        label: '已完成',
        class: 'status-badge is-success'
      },
      3: {
        label: '已取消',
        class: 'status-badge is-neutral'
      },
      default: {
        label: '未知',
        class: 'status-badge is-neutral'
      }
    };
    const filters = reactive({
      taskType: undefined,
      status: undefined,
      applicantUserId: undefined,
      dateRange: [todayString(), todayString()]
    });
    const tableData = ref([]);
    const loading = ref(false);
    const total = ref(0);
    const pagination = reactive({
      current: 1,
      size: 10,
      pages: 1
    });
    const exporting = ref(false);
    const handleDialogVisible = ref(false);
    const handleSubmitting = ref(false);
    const handleRow = ref(null);
    const handleForm = reactive({
      amount: '',
      remark: ''
    });
    const handleRemaining = computed(() => {
      if (!handleRow.value) return 0;
      return Math.max(0, toNumber(handleRow.value.totalAmount) - toNumber(handleRow.value.completedAmount));
    });

    // 处理任务弹窗只展示与任务类型匹配方向的限额：税筹派发(1)→转出，利润回填(2)→转入
    const handleQuotaIsIn = computed(() => handleRow.value?.taskType === 2);
    const handleCardRemaining = computed(() => handleQuotaIsIn.value ? handleRow.value?.inRemainingQuota : handleRow.value?.outRemainingQuota);
    const handleCardLimit = computed(() => handleQuotaIsIn.value ? handleRow.value?.inDailyLimit : handleRow.value?.outDailyLimit);
    const handleCardUsed = computed(() => handleQuotaIsIn.value ? handleRow.value?.inTodayUsed : handleRow.value?.outTodayUsed);
    const createDialogVisible = ref(false);
    const submitting = ref(false);
    const createFormRef = ref(null);
    const createForm = reactive({
      taskType: 1,
      ownerKey: null,
      cardId: null,
      totalAmount: '',
      remark: ''
    });
    const applicantCards = ref([]);
    const applicantCardsLoading = ref(false);
    const cardOwners = ref([]);
    const cardOwnersLoading = ref(false);
    const cardOwnerKeyword = ref('');

    // 卡主下拉支持按姓名或ID搜索（忽略大小写）
    const filteredCardOwners = computed(() => {
      const keyword = cardOwnerKeyword.value.trim().toLowerCase();
      if (!keyword) return cardOwners.value;
      return cardOwners.value.filter(owner => (owner.ownerName || '').toLowerCase().includes(keyword) || String(owner.ownerId).includes(keyword));
    });
    function filterCardOwners(keyword) {
      cardOwnerKeyword.value = keyword || '';
    }

    // 银行卡下拉按任务类型过滤：税筹派发(1)只能选出账账户，利润回填(2)只能选入账账户
    const filteredApplicantCards = computed(() => {
      return applicantCards.value.filter(card => card.accountType === createForm.taskType);
    });

    // 选定卡主后按 ownerType+ownerId 过滤其启用银行卡；匹配任务类型的卡只有一张时自动选中
    watch(() => createForm.ownerKey, async ownerKey => {
      createForm.cardId = null;
      applicantCards.value = [];
      if (!ownerKey) return;
      const [ownerType, ownerId] = String(ownerKey).split(':');
      applicantCardsLoading.value = true;
      try {
        const res = await getBankCardPage({
          page: 1,
          size: 50,
          ownerType: Number(ownerType),
          ownerId: Number(ownerId),
          status: 1
        });
        applicantCards.value = res.records || [];
        if (filteredApplicantCards.value.length === 1) {
          createForm.cardId = filteredApplicantCards.value[0].id;
        }
      } catch (error) {
        console.error('获取卡主银行卡失败', error);
      } finally {
        applicantCardsLoading.value = false;
      }
    });

    // 切换任务类型时清空已选银行卡；若过滤后恰好一张卡则自动选中
    watch(() => createForm.taskType, () => {
      createForm.cardId = null;
      if (filteredApplicantCards.value.length === 1) {
        createForm.cardId = filteredApplicantCards.value[0].id;
      }
    });
    const selectedCreateCard = computed(() => {
      return applicantCards.value.find(card => card.id === createForm.cardId) || null;
    });
    function cardRemaining(card, direction) {
      const limit = direction === 'OUT' ? card?.dailyOutLimit : card?.dailyInLimit;
      const used = direction === 'OUT' ? card?.todayOutUsed : card?.todayInUsed;
      if (limit === null || limit === undefined) return null;
      return Math.max(0, toNumber(limit) - toNumber(used));
    }

    // 创建任务弹窗只展示与所选银行卡账户类型匹配方向的限额：出账卡→转出，入账卡→转入
    const createCardDirection = computed(() => selectedCreateCard.value?.accountType === 2 ? 'IN' : 'OUT');
    const createCardRemaining = computed(() => cardRemaining(selectedCreateCard.value, createCardDirection.value));
    const createCardLimit = computed(() => createCardDirection.value === 'IN' ? selectedCreateCard.value?.dailyInLimit : selectedCreateCard.value?.dailyOutLimit);
    const createCardUsed = computed(() => createCardDirection.value === 'IN' ? selectedCreateCard.value?.todayInUsed : selectedCreateCard.value?.todayOutUsed);
    const createExceedTip = computed(() => {
      if (!selectedCreateCard.value) return '';
      const remaining = createCardRemaining.value;
      const amount = Number(createForm.totalAmount);
      if (remaining === null || !Number.isFinite(amount) || amount <= 0) return '';
      if (amount > remaining) {
        return `已超出该卡${createCardDirection.value === 'OUT' ? '转出' : '转入'}当日剩余限额（¥${formatAmount(remaining)}），请调整金额或更换银行卡`;
      }
      return '';
    });
    const createRules = {
      taskType: [{
        required: true,
        message: '请选择任务类型',
        trigger: 'change'
      }],
      ownerKey: [{
        required: true,
        message: '请选择卡主',
        trigger: 'change'
      }],
      cardId: [{
        required: true,
        message: '请选择指定银行卡',
        trigger: 'change'
      }],
      totalAmount: [{
        required: true,
        message: '请输入总金额',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          const num = Number(value);
          if (!Number.isFinite(num) || num <= 0) {
            callback(new Error('总金额必须为大于0的数字'));
            return;
          }
          callback();
        },
        trigger: 'blur'
      }]
    };
    function todayString() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    }

    // 顺延任务：创建日期早于当天且仍未完成（待处理/处理中）
    function isCarried(row) {
      if (!row.createTime || ![0, 1].includes(row.status)) return false;
      return String(row.createTime).slice(0, 10) < todayString();
    }
    function toNumber(value) {
      if (value === null || value === undefined || value === '') return 0;
      const num = Number(value);
      return Number.isFinite(num) ? num : 0;
    }
    function formatAmount(value) {
      return toNumber(value).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
    function progressPercent(row) {
      const totalAmount = toNumber(row.totalAmount);
      if (totalAmount <= 0) return 0;
      return Math.min(100, Math.round(toNumber(row.completedAmount) / totalAmount * 100));
    }
    function buildQueryParams() {
      return {
        taskType: filters.taskType,
        status: filters.status,
        applicantUserId: filters.applicantUserId ? Number(filters.applicantUserId) : undefined,
        startDate: filters.dateRange?.[0] || undefined,
        endDate: filters.dateRange?.[1] || undefined
      };
    }
    async function fetchTaskList() {
      loading.value = true;
      try {
        const res = await getFundTaskPage({
          page: pagination.current,
          size: pagination.size,
          ...buildQueryParams()
        });
        tableData.value = res.records || [];
        total.value = res.total || 0;
        pagination.pages = Math.max(1, Math.ceil(total.value / pagination.size));
      } catch (error) {
        ElMessage.error('获取资金任务列表失败');
        console.error(error);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      fetchTaskList();
    }
    function handleReset() {
      filters.taskType = undefined;
      filters.status = undefined;
      filters.applicantUserId = undefined;
      filters.dateRange = [todayString(), todayString()];
      handleSearch();
    }
    function handlePageChange(page) {
      if (page < 1 || page > pagination.pages) return;
      pagination.current = page;
      fetchTaskList();
    }
    function handlePageSizeChange(size) {
      pagination.size = size;
      pagination.current = 1;
      fetchTaskList();
    }
    function handleViewDetail(row) {
      router.push(`/tax/fund-tasks/${row.id}`);
    }
    function openHandleDialog(row) {
      handleRow.value = row;
      handleForm.amount = '';
      handleForm.remark = '';
      handleDialogVisible.value = true;
    }
    async function handleSubmitHandle() {
      const num = Number(handleForm.amount);
      if (!Number.isFinite(num) || num <= 0) {
        ElMessage.warning('请输入大于0的本笔金额');
        return;
      }
      handleSubmitting.value = true;
      try {
        await createFundTaskRecord(handleRow.value.id, {
          cardId: handleRow.value.cardId,
          amount: num,
          remark: handleForm.remark || undefined
        });
        ElMessage.success('操作已完成');
        handleDialogVisible.value = false;
        fetchTaskList();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        console.error(error);
      } finally {
        handleSubmitting.value = false;
      }
    }
    function handleCreate() {
      createForm.taskType = 1;
      createForm.ownerKey = null;
      createForm.cardId = null;
      createForm.totalAmount = '';
      createForm.remark = '';
      applicantCards.value = [];
      cardOwnerKeyword.value = '';
      createDialogVisible.value = true;
      fetchCardOwners();
    }
    async function fetchCardOwners() {
      cardOwnersLoading.value = true;
      try {
        cardOwners.value = (await getBankCardOwners()) || [];
      } catch (error) {
        console.error('获取已绑卡卡主失败', error);
      } finally {
        cardOwnersLoading.value = false;
      }
    }
    async function handleSubmitCreate() {
      try {
        await createFormRef.value.validate();
      } catch {
        return;
      }
      if (createExceedTip.value) {
        ElMessage.warning(createExceedTip.value);
        return;
      }
      submitting.value = true;
      try {
        await createFundTask({
          taskType: createForm.taskType,
          cardId: Number(createForm.cardId),
          totalAmount: Number(createForm.totalAmount),
          remark: createForm.remark || undefined
        });
        ElMessage.success('创建成功');
        createDialogVisible.value = false;
        fetchTaskList();
      } catch (error) {
        ElMessage.error(error.message || '创建失败');
        console.error(error);
      } finally {
        submitting.value = false;
      }
    }
    async function handleCancel(row) {
      try {
        await ElMessageBox.confirm(`确认取消任务「${row.title || row.taskNo}」吗？未完成的操作记录将一并取消。`, '取消确认', {
          confirmButtonText: '确认取消',
          cancelButtonText: '再想想',
          type: 'warning'
        });
      } catch {
        return;
      }
      try {
        await cancelFundTask(row.id);
        ElMessage.success('取消成功');
        fetchTaskList();
      } catch (error) {
        ElMessage.error(error.message || '取消失败');
        console.error(error);
      }
    }
    async function handleExport() {
      if (exporting.value) return;
      exporting.value = true;
      try {
        const blob = await exportFundTaskList(buildQueryParams());
        downloadBlob(blob, `税筹资金任务_${formatDateCompact()}.xlsx`);
        ElMessage.success('导出已开始');
      } catch (error) {
        ElMessage.error(error.message || '导出失败');
        console.error(error);
      } finally {
        exporting.value = false;
      }
    }
    onMounted(() => {
      fetchTaskList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "资金任务管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理税筹派发与利润回填资金任务，跟踪完成进度与操作记录。")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn-secondary inline-flex items-center gap-2",
          disabled: exporting.value,
          onClick: handleExport
        }, [_cache[18] || (_cache[18] = _createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        })], -1)), _createTextVNode(" " + _toDisplayString(exporting.value ? '导出中...' : '导出Excel'), 1)], 8, _hoisted_4)), [[_directive_permission, 'tax-planning:task:export']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn-primary inline-flex items-center gap-2",
          onClick: handleCreate
        }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
        })], -1), _createTextVNode(" 创建任务 ", -1)]))])), [[_directive_permission, 'tax-planning:task:create']])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchTaskList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: filters.taskType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.taskType = $event),
            placeholder: "任务类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: undefined
            }), _createVNode(_component_el_option, {
              label: "税筹派发",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "利润回填",
              value: 2
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => filters.status = $event),
            placeholder: "任务状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: undefined
            }), _createVNode(_component_el_option, {
              label: "待处理",
              value: 0
            }), _createVNode(_component_el_option, {
              label: "处理中",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "已完成",
              value: 2
            }), _createVNode(_component_el_option, {
              label: "已取消",
              value: 3
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(UserSelector, {
            modelValue: filters.applicantUserId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.applicantUserId = $event),
            placeholder: "选择用户",
            class: "form-control-sm filter-bar-field"
          }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: filters.dateRange,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => filters.dateRange = $event),
            type: "daterange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            class: "filter-bar-field is-wide form-date form-control-sm"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("table", _hoisted_8, [_cache[26] || (_cache[26] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "任务单号"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "用户"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "银行卡信息"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "总金额"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "已完成金额"), _createElementVNode("th", {
          class: "data-table-th text-center"
        }, "进度"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "创建时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(5, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, m => {
            return _createElementVNode("td", {
              key: m,
              class: _normalizeClass(["data-table-td", m === 10 ? 'data-table-sticky-right data-table-sticky-action' : ''])
            }, [...(_cache[21] || (_cache[21] = [_createElementVNode("div", {
              class: "h-4 bg-slate-200 rounded w-24"
            }, null, -1)]))], 2);
          }), 64))]);
        }), 64)) : tableData.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[22] || (_cache[22] = [_createElementVNode("td", {
          colspan: "10",
          class: "data-table-empty"
        }, [_createElementVNode("div", {
          class: "flex flex-col items-center"
        }, [_createElementVNode("svg", {
          class: "w-12 h-12 text-slate-300 mb-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })]), _createElementVNode("span", {
          class: "text-slate-500"
        }, "暂无资金任务")])], -1)]))])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(row.taskNo || '-'), 1), isCarried(row) ? (_openBlock(), _createElementBlock("span", _hoisted_12, "顺延")) : _createCommentVNode("", true)]), _createElementVNode("td", _hoisted_13, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", taskTypeMap[row.taskType]?.class || taskTypeMap.default.class])
          }, _toDisplayString(taskTypeMap[row.taskType]?.label || '未知'), 3)]), _createElementVNode("td", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(row.applicantName || '-'), 1), _createElementVNode("div", _hoisted_16, "ID: " + _toDisplayString(row.applicantUserId || '-'), 1)]), _createElementVNode("td", _hoisted_17, [row.cardId ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createElementVNode("div", _hoisted_18, _toDisplayString(row.cardHolderName || '-'), 1), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_19, _toDisplayString(row.cardNo || '-'), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(row.cardBankName || ''), 1)])], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_21, "-"))]), _createElementVNode("td", _hoisted_22, [_createElementVNode("span", _hoisted_23, "¥" + _toDisplayString(formatAmount(row.totalAmount)), 1)]), _createElementVNode("td", _hoisted_24, "¥" + _toDisplayString(formatAmount(row.completedAmount)), 1), _createElementVNode("td", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
            class: "h-full bg-primary-600 rounded-full",
            style: _normalizeStyle({
              width: `${progressPercent(row)}%`
            })
          }, null, 4)]), _createElementVNode("span", _hoisted_28, _toDisplayString(progressPercent(row)) + "%", 1)])]), _createElementVNode("td", _hoisted_29, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", taskStatusMap[row.status]?.class || taskStatusMap.default.class])
          }, _toDisplayString(taskStatusMap[row.status]?.label || '未知'), 3)]), _createElementVNode("td", _hoisted_30, _toDisplayString(row.createTime || '-'), 1), _createElementVNode("td", _hoisted_31, [_createElementVNode("div", _hoisted_32, [[0, 1].includes(row.status) && row.cardId ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-teal",
            title: "处理任务",
            "aria-label": "处理任务",
            onClick: $event => openHandleDialog(row)
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M13 10V3L4 14h7v7l9-11h-7z"
          })], -1)]))], 8, _hoisted_33)), [[_directive_permission, 'tax-planning:task:handle']]) : _createCommentVNode("", true), _createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "查看详情",
            "aria-label": "查看详情",
            onClick: $event => handleViewDetail(row)
          }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_34), [0, 1].includes(row.status) ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-danger",
            title: "取消任务",
            "aria-label": "取消任务",
            onClick: $event => handleCancel(row)
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
          })], -1)]))], 8, _hoisted_35)), [[_directive_permission, 'tax-planning:task:cancel']]) : _createCommentVNode("", true)])])]);
        }), 128))])])])]), _createVNode(AppPagination, {
          class: "pagination-bridge",
          pagination: pagination,
          total: total.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination", "total"])]), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: handleDialogVisible.value,
          size: "lg",
          onClose: _cache[8] || (_cache[8] = $event => handleDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "处理任务", -1)), _createElementVNode("p", _hoisted_37, _toDisplayString(handleRow.value?.taskNo || ''), 1)]), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[4] || (_cache[4] = $event => handleDialogVisible.value = false)
          }, [...(_cache[28] || (_cache[28] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), handleRow.value ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_cache[29] || (_cache[29] = _createElementVNode("div", {
            class: "text-xs text-slate-500 mb-1"
          }, "总金额", -1)), _createElementVNode("div", _hoisted_41, "¥" + _toDisplayString(formatAmount(handleRow.value.totalAmount)), 1)]), _createElementVNode("div", _hoisted_42, [_cache[30] || (_cache[30] = _createElementVNode("div", {
            class: "text-xs text-emerald-700 mb-1"
          }, "已完成", -1)), _createElementVNode("div", _hoisted_43, "¥" + _toDisplayString(formatAmount(handleRow.value.completedAmount)), 1)]), _createElementVNode("div", _hoisted_44, [_cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "text-xs text-amber-700 mb-1"
          }, "剩余", -1)), _createElementVNode("div", _hoisted_45, "¥" + _toDisplayString(formatAmount(handleRemaining.value)), 1)])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_cache[32] || (_cache[32] = _createElementVNode("span", {
            class: "text-xs text-slate-500 mr-2"
          }, "指定银行卡", -1)), _createTextVNode(" " + _toDisplayString(handleRow.value.cardHolderName || '-') + " ", 1), _createElementVNode("span", _hoisted_49, _toDisplayString(handleRow.value.cardNo || '-'), 1)]), _createElementVNode("div", _hoisted_50, _toDisplayString(handleRow.value.cardBankName || '-'), 1)]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, _toDisplayString(handleQuotaIsIn.value ? '转入剩余限额' : '转出剩余限额'), 1), _createElementVNode("div", _hoisted_53, [handleCardRemaining.value !== null && handleCardRemaining.value !== undefined ? (_openBlock(), _createElementBlock("span", _hoisted_54, "¥" + _toDisplayString(formatAmount(handleCardRemaining.value)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_55, "--"))]), _createElementVNode("div", _hoisted_56, " 日限额 " + _toDisplayString(handleCardLimit.value !== null && handleCardLimit.value !== undefined ? '¥' + formatAmount(handleCardLimit.value) : '--') + " · 当日已用 ¥" + _toDisplayString(formatAmount(handleCardUsed.value)), 1)])]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", null, [_createElementVNode("label", _hoisted_58, [_createTextVNode("本笔金额（" + _toDisplayString(handleRow.value.taskType === 2 ? '入账' : '出账') + "） ", 1), _cache[33] || (_cache[33] = _createElementVNode("span", {
            class: "text-red-500"
          }, "*", -1))]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => handleForm.amount = $event),
            type: "text",
            placeholder: "请输入本笔金额",
            class: "form-input w-48"
          }, null, 512), [[_vModelText, handleForm.amount]])]), _createElementVNode("div", _hoisted_59, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "form-label"
          }, "备注", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => handleForm.remark = $event),
            type: "text",
            placeholder: "可选填写备注",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, handleForm.remark]])])]), _cache[35] || (_cache[35] = _createElementVNode("p", {
            class: "text-xs text-slate-400"
          }, "提交后该笔操作直接记为已完成，任务完成金额同步累加；如金额有误可在任务详情中修改。", -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_60, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[7] || (_cache[7] = $event => handleDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: handleSubmitting.value,
            onClick: handleSubmitHandle
          }, _toDisplayString(handleSubmitting.value ? '提交中...' : '确认完成'), 9, _hoisted_61)])]),
          _: 1
        }, 8, ["visible"])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(AppModal, {
          visible: createDialogVisible.value,
          size: "lg",
          onClose: _cache[17] || (_cache[17] = $event => createDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_62, [_cache[37] || (_cache[37] = _createElementVNode("div", null, [_createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "创建资金任务"), _createElementVNode("p", {
            class: "text-sm text-slate-500"
          }, "创建税筹派发或利润回填任务，创建后可在详情页逐笔生成操作记录。")], -1)), _createElementVNode("button", {
            class: "p-1.5 text-slate-400 hover:text-slate-600",
            onClick: _cache[9] || (_cache[9] = $event => createDialogVisible.value = false)
          }, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_63, [_createVNode(_component_el_form, {
            ref_key: "createFormRef",
            ref: createFormRef,
            model: createForm,
            rules: createRules,
            "label-width": "100px"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "任务类型",
              prop: "taskType"
            }, {
              default: _withCtx(() => [_createElementVNode("label", _hoisted_64, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => createForm.taskType = $event),
                type: "radio",
                class: "form-radio",
                value: 1
              }, null, 512), [[_vModelRadio, createForm.taskType]]), _cache[38] || (_cache[38] = _createElementVNode("span", {
                class: "text-sm text-slate-700"
              }, "税筹派发", -1))]), _createElementVNode("label", _hoisted_65, [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => createForm.taskType = $event),
                type: "radio",
                class: "form-radio",
                value: 2
              }, null, 512), [[_vModelRadio, createForm.taskType]]), _cache[39] || (_cache[39] = _createElementVNode("span", {
                class: "text-sm text-slate-700"
              }, "利润回填", -1))])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "卡主",
              prop: "ownerKey"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: createForm.ownerKey,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => createForm.ownerKey = $event),
                placeholder: "请选择卡主（仅显示已绑定银行卡的卡主）",
                filterable: "",
                "filter-method": filterCardOwners,
                loading: cardOwnersLoading.value,
                class: "form-select w-full"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCardOwners.value, owner => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: owner.ownerType + ':' + owner.ownerId,
                    value: owner.ownerType + ':' + owner.ownerId,
                    label: (owner.ownerName || `卡主${owner.ownerId}`) + (owner.ownerType === 2 ? '（外部人员）' : '')
                  }, null, 8, ["value", "label"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "loading"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "指定银行卡",
              prop: "cardId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: createForm.cardId,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => createForm.cardId = $event),
                placeholder: createForm.ownerKey ? filteredApplicantCards.value.length ? '请选择该卡主的银行卡' : `该卡主暂无启用的${createForm.taskType === 1 ? '出账账户' : '入账账户'}` : '请先选择卡主',
                disabled: !createForm.ownerKey || filteredApplicantCards.value.length === 0,
                loading: applicantCardsLoading.value,
                class: "form-select w-full"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredApplicantCards.value, card => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: card.id,
                    value: card.id,
                    label: `${card.holderName} ${card.cardNo}（${card.bankName}）· ${card.accountType === 2 ? '入账' : '出账'}`
                  }, null, 8, ["value", "label"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "placeholder", "disabled", "loading"])]),
              _: 1
            }), selectedCreateCard.value ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, _toDisplayString(createCardDirection.value === 'IN' ? '转入剩余限额' : '转出剩余限额'), 1), _createElementVNode("div", _hoisted_69, [createCardRemaining.value !== null ? (_openBlock(), _createElementBlock("span", _hoisted_70, "¥" + _toDisplayString(formatAmount(createCardRemaining.value)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_71, "--"))]), _createElementVNode("div", _hoisted_72, " 日限额 " + _toDisplayString(createCardLimit.value !== null && createCardLimit.value !== undefined ? '¥' + formatAmount(createCardLimit.value) : '--') + " · 当日已用 ¥" + _toDisplayString(formatAmount(createCardUsed.value)), 1)])])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
              label: "总金额",
              prop: "totalAmount"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => createForm.totalAmount = $event),
                type: "text",
                placeholder: "请输入总金额（元）",
                class: "form-input w-full"
              }, null, 512), [[_vModelText, createForm.totalAmount]]), createExceedTip.value ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(createExceedTip.value), 1)) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "备注"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => createForm.remark = $event),
                rows: "3",
                placeholder: "可选填写备注信息",
                class: "form-textarea w-full resize-none"
              }, null, 512), [[_vModelText, createForm.remark]])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])]), _createElementVNode("div", _hoisted_74, [_createElementVNode("button", {
            class: "btn-secondary",
            onClick: _cache[16] || (_cache[16] = $event => createDialogVisible.value = false)
          }, "取消"), _createElementVNode("button", {
            class: "btn-primary",
            disabled: submitting.value,
            onClick: handleSubmitCreate
          }, _toDisplayString(submitting.value ? '提交中...' : '提交'), 9, _hoisted_75)])]),
          _: 1
        }, 8, ["visible"])]))]),
        _: 1
      });
    };
  }
};